import BreadCrumb from "../shared/BreadCrumb";

interface BreadcrumbLink {
    label: string;
    to: string;
    isCurrentPage: boolean;
}

export default function BreadCrumbRiplay() {
    const breadcrumbLinks: BreadcrumbLink[] = [
        { label: 'BERANDA', to: '/', isCurrentPage: false },
        { label: 'DOKUMEN LAINNYA', to: '/dokumen/dokumen-lainnya', isCurrentPage: true },

    ];
    return (
        <div className="bg-[#D9D9D9]">
            <div className="max-w-screen-2xl mx-auto pt-16 pb-1 p-4 md:p-5 lg:px-16">
                <h2 className="text-bprDarkBlue text-2xl font-poppinsBold">DOKUMEN LAINNYA</h2>
                <BreadCrumb links={breadcrumbLinks}></BreadCrumb>
            </div>
        </div>
    )
}